export const LogEnums = {
  INTO_PRODUCT_DETAIL: 0,
  ADD_CART: 1,
  INTO_PAY: 2,
  INTO_CHECKOUT: 3,
  INTO_CHECKOUT_SUCCESS: 4,
  INTO_CHECKOUT_FAILED: 5,
}